import { useCallback, useEffect, useState } from 'react';
import { when } from '../../lib/n4';
import { errText, pickList, siteApi, toMs } from './common';

interface SiteEvent { id: number; kind: string; text: string; by?: string | null; created_at: number | string }
const KIND_TEXT: Record<string, string> = { start: 'indítás', stop: 'leállítás', restart: 'újraindítás', deploy: 'kiadás', rollback: 'visszaállítás', backup: 'mentés', restore: 'visszaállítás', maintenance: 'karbantartás', build: 'építés', test: 'teszt', edge: 'edge', error: 'hiba', health: 'health', create: 'létrehozás', update: 'beállítás' };
// Az idővonal pöttye: a kész-szerű események telik (a meglévő .a-timeline k-* osztályai)
const dotClass = (k: string) => (k === 'deploy' || k === 'backup' || k === 'start' ? 'k-kesz' : k === 'error' || k === 'stop' ? 'k-hiba' : '');

// Események idővonala a részlet alján (GET …/events); a tick a szülőtől jön (akció után / élő eseményre újratölt).
export function EventsTimeline({ siteId, tick }: { siteId: number; tick: number }) {
  const [list, setList] = useState<SiteEvent[] | null>(null);
  const [err, setErr] = useState('');
  const [all, setAll] = useState(false);
  const load = useCallback(() => {
    siteApi<unknown>(siteId, '/events').then((r) => { setList(pickList<SiteEvent>(r, 'events')); setErr(''); }).catch((e) => setErr(errText(e, 'Események')));
  }, [siteId]);
  useEffect(() => { load(); }, [load, tick]);
  const shown = list ? (all ? list : list.slice(0, 12)) : [];

  return (
    <section className="a-site-events">
      <h3>Események</h3>
      {err && <div className="a-site-msg bad">{err}</div>}
      {list && list.length === 0 && <p className="a-site-note">Még nincs esemény.</p>}
      {shown.length > 0 && (
        <ul className="a-timeline">
          {shown.map((e) => (
            <li key={e.id} className={dotClass(e.kind)}>
              <time>{when(toMs(e.created_at))}</time><span className="a-site-evk">{KIND_TEXT[e.kind] ?? e.kind}</span>{e.by && <span className="ver">{e.by}</span>}
              {e.text && <p>{e.text}</p>}
            </li>
          ))}
        </ul>
      )}
      {list && list.length > 12 && <button className="a-btn sm ghost" onClick={() => setAll(!all)}>{all ? 'Kevesebb' : `Mind a ${list.length} esemény`}</button>}
    </section>
  );
}
